import React from 'react'
import classnames from 'classnames'
import { ICustomerOrder } from '../../../interfaces'
import './favourite-order-tag.scss'
import { TagAction } from '../../../hooks'
import { withFavouriteOrderHook } from '../../collections/reorder-collection/reorder-collection.component'
import { observer } from 'mobx-react'
import { collectionsStore } from '../../collections/collections.store'
import { FavouriteTagErrorModal } from '../../collections'
import { modalStore } from '../../shared'

interface IFavouriteOrderTag {
  currentOrder: ICustomerOrder
  orders: ICustomerOrder[]
  setFavouriteOrder?: Function
  updateOrderTags?: Function
}

interface IState {
  loading: boolean
}

// TODO: Find a better way to import SVG icons
const StarIcon = () => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 576 512' className={'fav-tag__icon'}>
    <path d='M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z' />
  </svg>
)
@observer
class FavouriteOrderTag extends React.Component<IFavouriteOrderTag, IState> {
  state: IState = {
    loading: false
  }

  handleUpdateSuccess = (): void => {
    setTimeout(() => {
      window.location.reload()
    }, 1000)
  }

  showErrorMessageModal = (): void => {
    modalStore.set(<FavouriteTagErrorModal callback={modalStore.toggle} />)
    modalStore.toggle()
  }

  handleSetFavourite = async () => {
    this.setState({ loading: true })
    // if the current order is already a favourite
    try {
      if (this.props.currentOrder.isFavourite) { // remove the existing favourite order tag
        const orderId = await this.props.updateOrderTags(this.props.currentOrder, TagAction.REMOVE)
        if (orderId) {
          return this.handleUpdateSuccess()
        } else {
          throw new Error('Removing the tag of the favourite order is failed.')
        }
      } else { // set the new favourite order tag
        const orderId = await this.props.setFavouriteOrder(this.props.currentOrder)
        if (orderId) {
          this.handleUpdateSuccess()
        } else {
          throw new Error('Setting the tag of the favourite order is failed.')
        }
      }
  } catch {
    this.setState({ loading: false })
    this.showErrorMessageModal()
  }
}

  render(): JSX.Element {
    if (!this.props.currentOrder.isFavourite) {
      this.props.currentOrder.isFavourite = collectionsStore.isFavouriteOrder(this.props.currentOrder.id)
    }

    return (
      <div className={classnames('fav-tag', !this.props.currentOrder.isFavourite && 'fav-tag--inactive')} onClick={this.handleSetFavourite}>
        {this.state.loading ? (
          <div className='fav-tag__loading-wrapper'>
            <div className='fav-tag__loading-wrapper__spinner' />
          </div>
        ) : (
          <>
            <StarIcon />
            <span>Favourites</span>
          </>
        )}
      </div>
    )
  }
}

export default withFavouriteOrderHook(FavouriteOrderTag)
